var map = {
	"./en/auth.json": [
		5021,
		21
	],
	"./en/browse.json": [
		1529,
		529
	],
	"./en/common.json": [
		9802,
		802
	],
	"./en/likes.json": [
		3457,
		457
	],
	"./en/msgs.json": [
		85,
		85
	],
	"./en/profile.json": [
		1432,
		432
	],
	"./en/registration.json": [
		4478,
		478
	],
	"./en/terms.json": [
		1734,
		734
	],
	"./ru/auth.json": [
		1783,
		783
	],
	"./ru/browse.json": [
		3239,
		239
	],
	"./ru/common.json": [
		1444,
		444
	],
	"./ru/likes.json": [
		5711,
		711
	],
	"./ru/msgs.json": [
		4931,
		931
	],
	"./ru/profile.json": [
		1394,
		394
	],
	"./ru/registration.json": [
		3896,
		896
	],
	"./ru/terms.json": [
		5556,
		556
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;